import SettingService from "Services/http/endpoints/setting/SettingService";
import StatusHandler from "Helpers/StatusHandler";
import {SETTIND_DESIGN_SUCCESS, SETTIND_MALI_SUCCESS, SETTIND_TOLID_SUCCESS } from "../actionTypes";
import { translatorf } from "Languages/Utility/translatorf";
import showNotify from "Helpers/Notify";

export const getAllSettingTolid = (params) => {
  return async (dispatch) => {
    try {
      const response = await SettingService.getAllSettingTolid(params);
      let err = StatusHandler(response);
        if (!err.isFail) {
          dispatch({
            type:SETTIND_TOLID_SUCCESS,
            settingTolidData:response.data.Value
          })
        }
      } catch (err) {
      console.error('[catch error]', err)
    }
  }
};

export const postSettingTolid = (data) => {
  return async (dispatch) => {
    try {
      const response = await SettingService.postSettingTolid(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        // dispatch(getAllSettingTolid());
        showNotify({
          text: translatorf('Production_settings_successfully_completed'),
          customClass: "success"
        });
      }
    } catch (e) {
    }
  };
};

export const getAllSettingDesign = (params) => {
  return async (dispatch) => {
    try {
      const response = await SettingService.getAllSettingDesign(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        dispatch({
          type:SETTIND_DESIGN_SUCCESS,
          settingDesignData:response.data.Value
        })
      }
    } catch (e) {
    }
  };
};

export const getAllSettingMali = (params) => {
  return async (dispatch) => {
    try {
      const response = await SettingService.getAllSettingMali(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        dispatch({
          type:SETTIND_MALI_SUCCESS,
          settingMaliData:response.data.Value
        })
      }
    } catch (e) {
    }
  };
};

export const postSettingMali = (data) => {
  return async (dispatch) => {
    try {
      const response = await SettingService.postSettingMali(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        //dispatch(getAllSettingMali());
        showNotify({
          text: translatorf('Financial_settings_completed_successfully'),
          customClass: "success"
        });
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

